/**
 * An input component which provides a number input with increment and
 * decrement buttons. Ensures that the input is a number with a minimum value
 * of zero.
 */
import React, { Component } from 'react'

import TextInputLabel from '~/components/text-input-label'

import { Button, Container, Input, Wrapper } from './quantity-input.styles'

export type Props = {
  id: string
  value: number
  min: number
  max: number
  className?: string
  onChange: (arg0: number) => void
  label?: string
}

export default class QuantityInput extends Component<Props> {
  static defaultProps = {
    min: 0,
    max: Infinity,
  }
  increment = () => {
    this.notifyChange(this.props.value + 1)
  }

  decrement = () => {
    this.notifyChange(this.props.value - 1)
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawInput = e.target.value
    this.notifyChange(parseInt(rawInput, 10))
  }

  decrementDisabled = () => this.props.value <= this.props.min

  incrementDisabled = () => this.props.value >= this.props.max

  notifyChange(newValue: number) {
    if (isNaN(newValue) || newValue < this.props.min) return

    if (newValue > this.props.max) return

    if (this.props.value !== newValue) {
      this.props.onChange(newValue)
    }
  }

  select(e: React.ChangeEvent<HTMLInputElement>) {
    e.target.select()
  }

  render() {
    const { id, value, min, max } = this.props

    return (
      <Container className={this.props.className}>
        <TextInputLabel>{this.props.label}</TextInputLabel>
        <Wrapper>
          <Button
            type="icon"
            className="decrement"
            id={`${id}-decrement`}
            glyph="minus"
            onClick={this.decrement}
            data-testid="decrement"
            disabled={this.decrementDisabled()}
          />
          <Input
            className="input"
            data-testid="quantity-input"
            type="number"
            step="1"
            id={id}
            value={value}
            min={min}
            max={max}
            onChange={this.onChange}
            onFocus={this.select}
          />
          <Button
            type="icon"
            data-testid="increment"
            className="increment"
            id={`${id}-increment`}
            glyph="plus"
            onClick={this.increment}
            disabled={this.incrementDisabled()}
          />
        </Wrapper>
      </Container>
    )
  }
}
